import { Direction } from '@angular/cdk/bidi';
import { DOCUMENT } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject, Input, OnInit } from '@angular/core';
import SwiperCore, { Keyboard, Navigation, Pagination } from 'swiper';
import { MarketingUspViewModel } from './marketing-usp.view-model';

SwiperCore.use([Keyboard, Pagination, Navigation]);

@Component({
  selector: 'osn-shared-marketing-usp',
  templateUrl: './marketing-usp.component.html',
  styleUrls: ['./marketing-usp.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MarketingUspComponent implements OnInit {
  @Input() public vm: MarketingUspViewModel;

  public lastActiveSwiperIndex = 0;

  constructor(@Inject(DOCUMENT) private readonly document: Document) {}

  public ngOnInit(): void {}

  get documentDir(): Direction {
    return this.document.dir === 'rtl' ? 'rtl' : 'ltr';
  }

  public swiperPaginationChange($event: { activeIndex: number }) {
    this.lastActiveSwiperIndex = $event.activeIndex;
  }
}
